import React from 'react';

interface ScreenEyeLevelProps {}

export function ScreenEyeLevel(props: Readonly<ScreenEyeLevelProps>) {
	return (
		<svg width={138} height={90} viewBox="0 0 138 90" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_20113)">
				<path
					fill="#7F7F7F"
					d="M40.522 56.837c.674 1.732 1.993 5.858-1.708 25.943-1.865 10.09-2.741 11.894-2.488 16.855a39.214 39.214 0 002.448 12.012c.216.727.5 1.368.729 1.976.228.607.261.894.354 1.358a15.95 15.95 0 01-12.69 18.622 16.233 16.233 0 01-13.981-3.676 36.94 36.94 0 01-2.738-3.145 28.088 28.088 0 01-6.233-13.808 27.443 27.443 0 01.146-7.358 58.196 58.196 0 012.159-7.417s1.115-3.852 1.77-7.584c.654-3.732.398-6.647-.84-14.902-1.777-11.798-2.343-13.74-2.51-15.767 0 0-.1-.873-.073-1.669-.042-5.078 3.028-11.346 3.337-11.989 2.383-4.775 3.295-4.656 5.703-9.897a18.94 18.94 0 001.984-5.72c.622-4.93-1.963-7.09-.747-9.038 1.516-2.431 7.166-1.866 10.75-.547 5.59 1.998 10.282 7.44 9.668 11.406a5.549 5.549 0 01-1.167 2.947c-1.164 1.361-2.61 1.303-3.357 2.735a3.79 3.79 0 00-.338 2.112c.201 2.446 2.179 3.222 4.567 6.196a38.341 38.341 0 015.255 10.355z"
				/>
				<path
					fill="#999"
					d="M44.653 16.41a40 40 0 01.162 7.284 41.311 41.311 0 01-.86 5.38 18.915 18.915 0 01-1.95 6.02 6.4 6.4 0 01-2.208 2.617 7.281 7.281 0 01-5.64.211 12.84 12.84 0 01-3.436-1.638c-1.535-.947-1.73-1.386-3.457-2.627a32.661 32.661 0 00-3.819-2.321c-3.377-1.817-3.524-1.259-5.225-2.384a13.249 13.249 0 01-4.753-5.871 18.06 18.06 0 01-.994-4.626 16.12 16.12 0 0132.165-2.056l.015.012zM29.813 98.084a6.928 6.928 0 01-9.55 2.201 7.229 7.229 0 01-2.72-3.064 29.24 29.24 0 01-.574-1.957 21.092 21.092 0 01-.628-4.15c-.135-2.818.394-3.88.367-6.344.048-3.098-.793-3.223-2.062-8.802a67.098 67.098 0 01-1.582-10.984c-.032-.91-.055-1.769-.093-2.546l-.014-.09c.006-1.103-.003-2.123.011-2.908a9.246 9.246 0 011.318-3.741 10.14 10.14 0 0114.02-3.17 10.493 10.493 0 014.503 5.647l.016.104c.133.882.255 1.686.467 2.476a.197.197 0 00.02.13 34.01 34.01 0 01.116 9.534c-.383 2.552-1.08 5.404-1.08 5.404-.609 2.374-.818 2.658-1.309 4.762a28.86 28.86 0 00-.99 6.172 22.931 22.931 0 00.544 6.14 6.755 6.755 0 01-.78 5.186z"
				/>
				<path d="M48.797 16.818h67.274" stroke="#445662" strokeDasharray="1.5 2" />
				<path
					fill="#445662"
					d="M122.477 2.27l-5.454 63.969c3.12.046 5.81-2.244 6.065-5.215l.874-10.232.032-.003 3.611-42.718c.251-2.972-2.028-5.523-5.128-5.801z"
				/>
				<path d="M125.879 43.336l19.889 39.234" stroke="#505A63" strokeLinecap="round" />
				<path
					fill="#71828F"
					d="M126.42 38.408l-1.56-.089-.983 11.244 1.396.079c.639.037 1.205-.42 1.262-1.02l.94-9.063c.057-.6-.415-1.115-1.055-1.151z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_20113">
					<path fill="#fff" d="M0 0H138V90H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
